'use client';

import ArrowLeftCircle from '@/components/icons/ArrowLeftCircle';
import ArrowRightCircle from '@/components/icons/ArrowRightCircle';
import { FC, ReactNode, useEffect, useState } from 'react';
import styles from './style.module.scss';

// RANGE_SELECTION define the range selection for min and max
// exemple : for RANGE_SELECTION = 2 and pageIndex = 4 =>  ...23[4]56...
//           for RANGE_SELECTION = 3 and pageIndex = 6 =>  ...345[6]789...
const RANGE_SELECTION = 2;

const Paginator: FC<{
  max: number;
  pageIndex: number;
  onChange: (pageIndex: number) => void;
  hasNext: boolean;
  hasPrev: boolean;
  className?: string;
}> = ({ max, pageIndex, onChange, hasPrev, hasNext, className }) => {
  const [showFirst, setShowFirst] = useState(false);
  const [showLast, setShowLast] = useState(false);

  const [range, setRange] = useState({ min: 0, max: 0 });

  useEffect(() => {
    const newRange = {
      min: Math.max(0, pageIndex - RANGE_SELECTION),
      max: 0,
    };
    newRange.max = Math.min(max, newRange.min + (RANGE_SELECTION * 2 + 1));

    if (newRange.min > 0) {
      setShowFirst(true);
    } else {
      setShowFirst(false);
    }

    if (newRange.max < max) {
      setShowLast(true);
    } else {
      setShowLast(false);
    }
    setRange(newRange);
  }, [pageIndex, max]);

  return (
    <div className={styles.container + ' ' + className ?? ''}>
      <div
        className={styles.prev + ' ' + (!hasPrev ? styles.hide : '')}
        onClick={() => onChange(pageIndex - 1)}
      >
        <ArrowLeftCircle />
      </div>
      {showFirst ? (
        <>
          <div className={styles.step} onClick={() => onChange(0)}>
            1
          </div>
          <div>...</div>
        </>
      ) : null}

      {(() => {
        const res: ReactNode[] = [];
        for (let i = range.min; i < range.max; i++) {
          res.push(
            <div
              key={i}
              className={
                styles.step + ' ' + (pageIndex === i ? styles.selected : '')
              }
              onClick={() => onChange(i)}
            >
              {i + 1}
            </div>
          );
        }
        return res;
      })()}

      {showLast ? (
        <>
          <div>...</div>
          <div className={styles.step} onClick={() => onChange(max - 1)}>
            {max}
          </div>
        </>
      ) : null}
      <div
        className={styles.next + ' ' + (!hasNext ? styles.hide : '')}
        onClick={() => onChange(pageIndex + 1)}
      >
        <ArrowRightCircle />
      </div>
    </div>
  );
};

export default Paginator;
